import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session';
import './AppShell.css';

type NavItem = { to: string; label: string; icon: string; end?: boolean };

// Mobile bottom tab bar — 5 slots. "More" opens the rest.
const NAV: NavItem[] = [
  { to: '/', label: 'Home', icon: '🏠', end: true },
  { to: '/schedule', label: 'Schedule', icon: '📅' },
  { to: '/messages', label: 'Messages', icon: '💬' },
  { to: '/families', label: 'Families', icon: '👪' },
  { to: '/more', label: 'More', icon: '⋯' },
];

// Desktop sidebar shows everything.
const SIDEBAR_EXTRA: NavItem[] = [
  { to: '/invoices', label: 'Invoices', icon: '🧾' },
  { to: '/mileage', label: 'Mileage', icon: '🚗' },
  { to: '/broadcast', label: 'Broadcast', icon: '📣' },
  { to: '/discover', label: 'Find families', icon: '🔍' },
  { to: '/documents', label: 'Docs', icon: '📁' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
];

export function AppShell() {
  const profile = useSession((s) => s.profile);
  const signOut = useSession((s) => s.signOut);
  const navigate = useNavigate();

  const handleSignOut = () => {
    signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="shell">
      <aside className="shell__sidebar">
        <div className="shell__brand">
          <span className="shell__brand-mark">✦</span>
          <span>FASD Assist</span>
        </div>
        <nav className="shell__nav">
          {[...NAV.filter((i) => i.to !== '/more'), ...SIDEBAR_EXTRA].map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `shell__nav-link${isActive ? ' is-active' : ''}`
              }
            >
              <span className="shell__nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="shell__sidebar-foot">
          <div className="shell__who">
            <div className="shell__who-name">{profile?.name ?? 'Provider'}</div>
            <div className="shell__who-role muted">{profile?.organization || profile?.email}</div>
          </div>
          <button className="btn btn--ghost btn--block" onClick={handleSignOut}>
            Log out
          </button>
        </div>
      </aside>

      <div className="shell__main">
        <header className="shell__topbar">
          <span className="shell__topbar-title">
            {profile?.name ? `Hi, ${profile.name.split(' ')[0]}` : 'Provider Portal'}
          </span>
          <button className="shell__topbar-signout" onClick={handleSignOut}>
            Log out
          </button>
        </header>

        <main className="shell__content">
          <Outlet />
        </main>

        <nav className="shell__tabbar">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `shell__tab${isActive ? ' is-active' : ''}`
              }
            >
              <span className="shell__tab-icon">{item.icon}</span>
              <span className="shell__tab-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
